<!-- Daily Usage data-->
<div class="white-box main-black mt-4 p-4 border-radius">
	<div class="col-sm-6 col-md-6">
		<h4 class="mb-2">
			{{'perf_analytic.daily_truck_usage_report' | translate}}
		</h4>
	</div>

	<div class="d-flex flex-wrap gap-3 mb-4 align-items-end">
		<div class="col-xl-4 col-md-4">
			<div class="input-group">
				<div class="input-group-prepend">
					<span class="input-group-text">{{'g.start_date' | translate}}</span>
				</div>
				<input type="text" [ngClass]="{'invalid-input': invalidTruckUsageDate}" class="form-control" placeholder="mm/dd/yyyy" name="dp1" (ngModelChange)="changeDate('fromDate', $event)" [(ngModel)]="fromDate" bsDatepicker #d1="bsDatepicker" [bsConfig]="{containerClass: 'theme-dark-blue'}" [minDate]="minDate" [maxDate]="toDate">
				<div class="input-group-append pointer" (click)="d1.toggle()">
					<span class="input-group-text"><i class="fa fa-calendar"></i></span>
				</div>
			</div>
		</div>

		<div class="col-xl-4 col-md-4">
			<div class="input-group">
				<div class="input-group-prepend">
					<span class="input-group-text">{{'g.end_date' | translate}}</span>
				</div>
				<input type="text" [ngClass]="{'invalid-input': invalidTruckUsageDate}" class="form-control" placeholder="mm/dd/yyyy" name="dp2" (ngModelChange)="changeDate('toDate', $event)" [(ngModel)]="toDate" bsDatepicker #d2="bsDatepicker" [bsConfig]="{containerClass: 'theme-dark-blue'}" [minDate]="minDate" [maxDate]="toDate">
				<div class="input-group-append pointer" (click)="d2.toggle()">
					<span class="input-group-text"><i class="fa fa-calendar"></i></span>
				</div>
			</div>
		</div>
		<div class="col-xl-4 col-md-4">
			<ng-select class="select full-width"
				[searchable]="false"
				[clearable]="false"
				[items]="truckTypeList"
				bindLabel="label"
				bindValue="value"
				[placeholder]="'devices.truck_type' | translate"
				[(ngModel)]="selectedDailyUsageTruckTypeFilter"
				(change)="getSiteDevicesUsageData()"
			>
			</ng-select>
		</div>
	</div>
	<div>
		<sct-custom-table
			[data]="dailyTruckUsageReportsConfig.data"
			[columnsConfig]="dailyTruckUsageReportsConfig.column"
			[config]="dailyTruckUsageReportsConfig.config"
		>
		</sct-custom-table>
	</div>
</div>

<!-- Monthly / Quarterly Truck usage Report-->
<div class="white-box main-black mt-4 p-4 border-radius">
	<div class="col-sm-6 col-md-6">
		<h4>
			{{'perf_analytic.monthly_quarter_truck_usage_report' | translate}}
		</h4>
	</div>
	<ng-container *ngIf="!monthlyQuarterlyNoData; else noDataToShow">
	<div class="d-flex flex-wrap gap-3 mb-4 align-items-end">
		<!-- years list -->
		<div class="col-xl-4 col-md-4">
			<ng-select
				[searchable]="false"
				class="mr-auto w-100"
				[items]="yearList"
				bindLabel="label"
				bindValue="id"
				placeholder="{{'site.year' | translate}}"
				name="year"
				[(ngModel)]="selectedYear"
				(change)="getMonthlyQuarterlyUsageReport()"
				[clearable]="false"
			>
			</ng-select>
		</div>

		<!-- Monthly or Quarterly drop-down -->
		<div class="col-xl-4 col-md-4">
			<ng-select
				[searchable]="false"
				class="mr-auto w-100"
				[items]="periodTypes"
				bindLabel="label"
				bindValue="id"
				placeholder="{{'perf_analytic.period' | translate}}"
				name="period"
				[(ngModel)]="selectedPeriodType"
				(ngModelChange)="changePeriodType()"
				[clearable]="false"
			>
			</ng-select>
		</div>
		<div class="col-xl-4 col-md-4">
			<ng-select class="select full-width"
				[searchable]="false"
				[clearable]="false"
				[items]="truckTypeList"
				bindLabel="label"
				bindValue="value"
				placeholder="{{'devices.truck_type' | translate}}"
				[(ngModel)]="selectedMonthlyQuarterlyTruckTypeFilter"
				(change)="getMonthlyQuarterlyUsageReport()"
			>
			</ng-select>
		</div>
	</div>
	<div>
		<sct-custom-table
			[columnsConfig]="monthlyQuarterlyTruckReport.column"
			[data]="monthlyQuarterlyTruckReport.data"
			[config]="monthlyQuarterlyTruckReport.config"
		>
		</sct-custom-table>
	</div>
	</ng-container>
</div>

<!--Daily / Monthly Truck Usage Charts-->
<div class="white-box main-black mt-4 p-4 border-radius">
	<div class="row mb-4">
		<div class="col">
			<h4>
				{{'fleet_reports.truck_usage_charts' | translate}}
			</h4>
		</div>
	</div>

	<div class="row mb-4">
		<!-- years list -->
		<div class="col-sm-6 col-md-2 d-inline-flex">
			<ng-select
				[searchable]="false"
				class="mr-auto w-100"
				[items]="yearList"
				bindLabel="label"
				bindValue="id"
				placeholder="{{'site.year' | translate}}"
				name="year"
				[(ngModel)]="monthlyDailySelectedYear"
				(ngModelChange)="getMonthlyDailyChartsData()"
				[clearable]="false"
			>
			</ng-select>
		</div>

		<!-- Monthly or Daily drop-down -->
		<div class="col-sm-6 col-md-2 d-inline-flex">
			<ng-select
				class="mr-auto w-100"
				[searchable]="false"
				[items]="dailyMonthlyPeriod"
				bindLabel="label"
				bindValue="id"
				placeholder="{{'perf_analytic.period' | translate}}"
				name="period"
				[(ngModel)]="selectedMonthlyDailyPeriod"
				(change)="getMonthlyDailyChartsData()"
				[clearable]="false"
			>
			</ng-select>
		</div>

		<!-- Total Or Daily Average options -->
		<div class="col-sm-6 col-md-2 d-inline-flex" *ngIf="selectedMonthlyDailyPeriod !== 'daily'">
			<ng-select
				class="mr-auto w-100"
				[searchable]="false"
				[items]="graphTypes"
				bindLabel="label"
				bindValue="id"
				placeholder="{{'g.data' | translate}}"
				name="graph_type"
				[(ngModel)]="selectedGraphTypes"
				[clearable]="false"
			>
			</ng-select>
		</div>

		<!--Site Devices Truck Types-->
		<div class="col-sm-6 col-md-2 d-inline-flex">
			<ng-select
				class="mr-auto w-100"
				[searchable]="false"
				[items]="truckTypeList"
				bindLabel="label"
				bindValue="value"
				placeholder="{{'devices.truck_type' | translate}}"
				[(ngModel)]="selectedMonthlyDailyTruckTypeFilter"
				(change)="getMonthlyDailyChartsData()"
				[clearable]="false"
			>
			</ng-select>
		</div>

		<div class="d-inline-flex ml-auto" *ngIf="!noData">
			<button  class="btn fa fa-print fa-lg" printTitle="{{'fleet_reports.truck_usage_charts' | translate}}" [useExistingCss]="true" printSectionId="truck_usage_charts" ngxPrint title="{{'g.print' | translate}}"></button>
			<button class="fa fa-upload btn" title="{{'g.export_to_csv' | translate}}" (click)="exportDataToCsv()"></button>
		</div>
	</div>

	<div id="truck_usage_charts" *ngIf="!noData; else noDataToShow">
		<app-print-filters title="fleet_reports.truck_usage_charts" [filters]="printFilters"></app-print-filters>
		<div class="row" *ngIf="['inuse_hours', 'all'].includes(selectedCharts)">
			<sct-charts
				*ngIf="(selectedGraphTypes == 'total' && chartsData.total_inuse_hours[monthlyDailySelectedYear]) || (selectedGraphTypes == 'average' && chartsData.average_inuse_hours[monthlyDailySelectedYear])"
				id="inuse_hours"
				title="{{(selectedGraphTypes == 'total' ? 'fleet_reports.total_inuse_hours' : 'site_trucks_report.average_inuse_hours') | translate}}"
				[data]="selectedGraphTypes == 'total' ? chartsData.total_inuse_hours[monthlyDailySelectedYear] : chartsData.average_inuse_hours[monthlyDailySelectedYear]"
				[columnNames]="['g.time' | translate, (selectedGraphTypes == 'total' ? 'fleet_reports.total_inuse_hours' : 'site_trucks_report.average_inuse_hours') | translate, tooltipConfig]"
				[options]="timeChartConfig"
				[type]="'ColumnChart'"
				[height]="500"
			></sct-charts>
		</div>
		<div class="row" *ngIf="['inuse_ah', 'all'].includes(selectedCharts)">
			<sct-charts
				*ngIf="(selectedGraphTypes == 'total' && chartsData.total_inuse_ah[monthlyDailySelectedYear]) || (selectedGraphTypes == 'average' && chartsData.average_inuse_ah[monthlyDailySelectedYear])"
				id="inuse_ah"
				title="{{(selectedGraphTypes == 'total' ? 'fleet_reports.total_inuse_ah' : 'site_trucks_report.average_inuse_ah') | translate}}"
				[data]="selectedGraphTypes == 'total' ? chartsData.total_inuse_ah[monthlyDailySelectedYear] : chartsData.average_inuse_ah[monthlyDailySelectedYear]"
				[columnNames]="['g.time' | translate, (selectedGraphTypes == 'total' ? 'fleet_reports.total_inuse_ah' : 'site_trucks_report.average_inuse_ah') | translate]"
				[options]="chartObject.config"
				[type]="'ColumnChart'"
				[height]="500"
			></sct-charts>
		</div>
		<div class="row" *ngIf="['inuse_kwh', 'all'].includes(selectedCharts)">
			<sct-charts
				*ngIf="(selectedGraphTypes == 'total' && chartsData.total_inuse_kwh[monthlyDailySelectedYear]) || (selectedGraphTypes == 'average' && chartsData.average_inuse_kwh[monthlyDailySelectedYear])"
				id="inuse_kwh"
				title="{{(selectedGraphTypes == 'total' ? 'fleet_reports.total_inuse_kwh' : 'site_trucks_report.average_inuse_kwh') | translate}}"
				[data]="selectedGraphTypes == 'total' ? chartsData.total_inuse_kwh[monthlyDailySelectedYear] : chartsData.average_inuse_kwh[monthlyDailySelectedYear]"
				[columnNames]="['g.time' | translate, (selectedGraphTypes == 'total' ? 'fleet_reports.total_inuse_kwh' : 'site_trucks_report.average_inuse_kwh') | translate]"
				[options]="chartObject.config"
				[type]="'ColumnChart'"
				[height]="500"
			></sct-charts>
		</div>
		<div class="row" *ngIf="['travel_lift_time', 'all'].includes(selectedCharts)">
			<sct-charts
				*ngIf="(selectedGraphTypes == 'total' && chartsData.total_travel_lift_time[monthlyDailySelectedYear]) || (selectedGraphTypes == 'average' && chartsData.average_travel_lift_time[monthlyDailySelectedYear])"
				id="travel_lift_time"
				title="{{(selectedGraphTypes == 'total' ? 'fleet_reports.total_travel_lift_time' : 'site_trucks_report.average_travel_lift_time') | translate}}"
				[data]="selectedGraphTypes == 'total' ? chartsData.total_travel_lift_time[monthlyDailySelectedYear] : chartsData.average_travel_lift_time[monthlyDailySelectedYear]"
				[columnNames]="travelLiftTimeChartColumnNames"
				[options]="travelLiftTimeChartConfig"
				[type]="'ColumnChart'"
				[height]="500"
			></sct-charts>
		</div>
	</div>
</div>

<app-end-voltage-chart
	[event_type]="'inuse'"
	[sctDeviceType]="DeviceFactory.types.iotah"
	[title]="'site_trucks_report.truck_inuse_end_voltage'"
	[options]="{hasTruckTypeOptions: true, hasCapacityOptions: false, hasBatteryOptions: false}" >
</app-end-voltage-chart>

<app-power-usage-charts
	[hasTruckTypesFilter]="true"
	[config]="powerChartColumnConfig"
	[tooltipText]="'site_power_usage_chart'"
	[deviceTypes]="truckDevicesTypes"
></app-power-usage-charts>

<ng-template #noDataToShow class="mt-4">
	<div class="alert alert-info">{{'g.no_data_to_show' | translate}}</div>
</ng-template>
